var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-content", { attrs: { id: "team" } }, [
    _c("div", { staticClass: "teamheadimg" }, [
      _c("div", { staticClass: "imgcover" }),
      _c("img", {
        staticClass: "teamimg",
        attrs: { src: "http://cdn.dongliyuanlin.com/image/team.jpg", alt: "" }
      })
    ]),
    _c("div", { staticClass: "team-wrap" }, [
      _c("div", { staticClass: "team-list" }, [
        _c(
          "ul",
          _vm._l(_vm.descPageData, function(item, index) {
            return _c(
              "li",
              { key: item.id, staticClass: "project-list_detail" },
              [
                _c("nuxt-link", { attrs: { to: "/us/teams/" + item.id } }, [
                  _c("div", { staticClass: "imgcover" }),
                  _c("img", { attrs: { src: item.mainImg, alt: "" } })
                ]),
                _c("h3", [_vm._v(_vm._s(item.title))])
              ],
              1
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db137076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db137076","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/team.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-db137076","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/us/team.vue
// module chunks = 3